import axios from '@/libs/api.request'

/**
 * 导出车辆位置
 */
export const exportLocation = () => {
    return axios.request({
        url: '/api/admin/carinfo/exportLocation',
        method: 'post'
    })
}
